import React, { FC } from "react";
import { useSelector } from "react-redux";

import { Typography } from "@mui/material";
import { H1, H2 } from "#common/headings";
import { ApplicationState } from "#store/types";
import { Json } from "#common/Json";
import { useLocation } from "react-router";

export const NotFoundPage: FC = () => {
    let location = useLocation();
    location.pathname;
    const locationPath = location.pathname;

    return (
        <>
            <H1 align="center">
                I'm sorry Dave, I'm afraid I can't do that.
                <br />
            </H1>
            <H2>404 - File Not Found</H2>
            <Typography align="center">
                Location not found: {locationPath}
            </Typography>
            <Json src={location} />
        </>
    );
};
